// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_gm-3";
export var flatBottomCorners = "_gm-5";
export var productImage = "_gm-0";
export var quantityContainer = "_gm-2";
export var quantityHeader = "_gm-6";
export var tooltip = "_gm-1";
export var wrapAndEllipsesOverflow = "_gm-4";